import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import { enableConversionReportingRpc } from 'automation-ui-canvas/__generated__/chirp/com/hubspot/automation/reporting/rpc/ConversionRpc';
import { METRICS_LIMITS } from 'automation-ui-canvas/constants/Gates';
import EnrollmentConversionFiltersSection from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnrollmentConversionFiltersSection';
import EnrollmentConversionSidePanelContent from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnrollmentConversionSidePanelContent';
import EnrollmentConversionTrackingToggle from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnrollmentConversionTrackingToggle';
import { FETCH_ENROLLMENT_CONVERSION_STATUS } from 'automation-ui-canvas/containers/enrollment-conversion/wireGetEnrollmentConversionTrackingStatus';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { registerMutation, useMutation, useQuery } from 'data-fetching-client';
import authHttpClient from 'hub-http/clients/apiClient';
import { useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PANEL_WIDTH = 500;
const StyledSidePanel = styled(UIPanel).withConfig({
  displayName: "EnrollmentConversionSidePanel__StyledSidePanel",
  componentId: "sc-8elu07-0"
})(["position:fixed;", " overflow:inherit;"], props => `height: calc(100vh - ${props.canvastopoffset}px) !important;
      top: ${props.canvastopoffset}px;`);
const chirpClient = createRpcClientV2({
  hubHttpClient: authHttpClient
});
export const UPDATE_ENROLLMENT_CONVERSION_STATUS = registerMutation({
  fieldName: 'updateEnrollmentConversionStatus',
  args: ['flowId', 'conversionReportingEnabled'],
  fetcher({
    flowId,
    conversionReportingEnabled
  }) {
    return chirpClient.call(enableConversionReportingRpc, {
      request: {
        flowId: flowId !== null && flowId !== void 0 ? flowId : 0,
        conversionReportingEnabled
      }
    });
  }
});
const EnrollmentConversionSidePanel = ({
  canvasTopOffset,
  flow
}) => {
  var _reportEnabledData$fe, _reportEnabledData$fe2, _reportEnabledData$fe3, _reportEnabledData$fe4, _reportEnabledData$fe5, _reportEnabledData$fe6, _reportEnabledData$fe7, _reportEnabledData$fe8, _reportEnabledData$fe9;
  const [errorMessage, setErrorMessage] = useState();
  const isUngatedForMetricsLimits = useIsUngated(METRICS_LIMITS);
  const {
    data: reportEnabledData,
    loading: isReportEnabledDataLoading,
    refetch: refetchReportingEnabledStatus
  } = useQuery(FETCH_ENROLLMENT_CONVERSION_STATUS, {
    variables: {
      flowId: flow.flowId
    },
    fetchPolicy: 'network-only'
  });
  const [updateConversionReportingEnabled, {
    loading: updateLoading
  }] = useMutation(UPDATE_ENROLLMENT_CONVERSION_STATUS, {
    variables: {
      flowId: flow === null || flow === void 0 ? void 0 : flow.flowId,
      conversionReportingEnabled: true
    },
    onCompleted: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      refetchReportingEnabledStatus();
      setErrorMessage(undefined);
    },
    onError: () => {
      setErrorMessage( /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentConversion.panel.updateErrorMessage"
      }));
    }
  });
  if (isReportEnabledDataLoading) {
    return null;
  }
  const isReportingEnabled = (_reportEnabledData$fe = reportEnabledData === null || reportEnabledData === void 0 ? void 0 : reportEnabledData.fetchEnrollmentConversionStatus.conversionReportingEnabled) !== null && _reportEnabledData$fe !== void 0 ? _reportEnabledData$fe : false;
  const {
    flowsEnabledLimit: limit = 0,
    flowsCurrentlyEnabled: enabledCount = 0
  } = (_reportEnabledData$fe2 = reportEnabledData === null || reportEnabledData === void 0 || (_reportEnabledData$fe3 = reportEnabledData.fetchEnrollmentConversionStatus) === null || _reportEnabledData$fe3 === void 0 ? void 0 : _reportEnabledData$fe3.portalEnablementStatistics) !== null && _reportEnabledData$fe2 !== void 0 ? _reportEnabledData$fe2 : {};
  const isEnablementRecommended = (_reportEnabledData$fe4 = reportEnabledData === null || reportEnabledData === void 0 || (_reportEnabledData$fe5 = reportEnabledData.fetchEnrollmentConversionStatus) === null || _reportEnabledData$fe5 === void 0 ? void 0 : _reportEnabledData$fe5.shouldRecommendEnablement) !== null && _reportEnabledData$fe4 !== void 0 ? _reportEnabledData$fe4 : false;
  const shouldAllowEnablement = (_reportEnabledData$fe6 = reportEnabledData === null || reportEnabledData === void 0 || (_reportEnabledData$fe7 = reportEnabledData.fetchEnrollmentConversionStatus) === null || _reportEnabledData$fe7 === void 0 ? void 0 : _reportEnabledData$fe7.shouldAllowEnablement) !== null && _reportEnabledData$fe6 !== void 0 ? _reportEnabledData$fe6 : false;
  const reportEnabledTimeStamp = (_reportEnabledData$fe8 = reportEnabledData === null || reportEnabledData === void 0 || (_reportEnabledData$fe9 = reportEnabledData.fetchEnrollmentConversionStatus) === null || _reportEnabledData$fe9 === void 0 ? void 0 : _reportEnabledData$fe9.lastUpdateTimestamp) !== null && _reportEnabledData$fe8 !== void 0 ? _reportEnabledData$fe8 : 0;
  return /*#__PURE__*/_jsxs(StyledSidePanel, {
    "data-test-id": "enrollment-conversion-side-panel",
    width: PANEL_WIDTH,
    canvastopoffset: canvasTopOffset,
    align: "right",
    panelClassName: "m-all-0 p-all-0",
    children: [!isReportingEnabled && !isUngatedForMetricsLimits && /*#__PURE__*/_jsx(EnrollmentConversionTrackingToggle, {
      isReportingEnabled: isReportingEnabled
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      ,
      setReportingEnabled: () => updateConversionReportingEnabled(),
      loading: updateLoading,
      errorMessage: errorMessage
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(EnrollmentConversionFiltersSection, {
          flowId: flow.flowId,
          isReportingEnabled: isReportingEnabled
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          ,
          setReportingEnabled: () => updateConversionReportingEnabled(),
          reportEnabledTimeStamp: reportEnabledTimeStamp,
          limit: limit,
          enabledCount: enabledCount,
          isEnablementRecommended: isEnablementRecommended,
          shouldAllowEnablement: shouldAllowEnablement,
          errorMessage: errorMessage
        }), /*#__PURE__*/_jsx(EnrollmentConversionSidePanelContent, {
          flowId: flow.flowId,
          isReportingEnabled: isReportingEnabled
        })]
      })
    })]
  });
};
export default EnrollmentConversionSidePanel;